Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.TextFieldType = module.exports.default = {
	DYNAMIC: "dynamic",
	INPUT: "input"
};